import './bootstrap';
import '../css/app.css';
import 'primeicons/primeicons.css'

import.meta.glob([
    '../images/**',
    '../fonts/**',
]);

import {createApp} from 'vue';
import PrimeVue from 'primevue/config';
import Card from 'primevue/card';
import Tag from 'primevue/tag';
import Fieldset from 'primevue/fieldset';
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import {Form} from '@primevue/forms';
import axios from 'axios';
import MyPreset from "./preset/mytheme";
import Login from './components/LoginForm.vue';
import Register from './components/RegisterForm.vue';
import DatatableForm from "./components/DatatableForm.vue";
import DatatableAdvance from "./components/DatatableAdvance.vue";
import DatatableTicketing from "./components/DatatableTicketing.vue";
import DatatableCellEdit from "./components/DatatableCellEdit.vue";
import DatatableAdvanceExpandable from "./components/DatatableAdvanceExpandable.vue"
import DatatableRowEdit from "./components/DatatableRowEdit.vue";
import MenuSx from './components/MenuSx.vue';
import MenuStrumenti from './components/MenuStrumenti.vue';
import Grafici from './components/Grafici.vue';
import SingleForm from "./components/SingleForm.vue";
import UpdateInfoThreadForm from "./components/UpdateInfoThreadForm.vue";
import InnerThreadForm from "./components/InnerThreadForm.vue";
import InnerThreadFormWithTabs from "./components/InnerThreadFormWithTabs.vue";
import ButtonModalForm from "./components/ButtonModalForm.vue"
import SeparaTicketModal from "./components/SeparaTicketModal.vue"

import FormInput from "./components/FormInput.vue";
import DipendentiForm from "./components/DipendentiForm.vue";
import VerifyTicketForm from "./components/VerifyTicketForm.vue";
import ConfirmTicket from "./components/ConfirmTicket.vue";
import DdtForm from "./components/DdtForm.vue";
import DdtInviaForm from "./components/DdtInviaForm.vue";
import CustomDrawer from "./components/Drawer.vue";
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import Toast from 'primevue/toast';
import Tree from 'primevue/tree';

import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import {VueReCaptcha} from 'vue-recaptcha-v3';
import Chart from 'primevue/chart';
import DatePicker  from 'primevue/datepicker';
import Tooltip from 'primevue/tooltip';
import ToggleSwitch from 'primevue/toggleswitch';
import Column from 'primevue/column';
import FileMultiploUpload from "./components/FileMultiploUpload.vue";
import FileUploadMapped from "./components/FileUploadMapped.vue";
import GiroSettimanale from "./components/GiroSettimanale.vue";
import SearchActionButtons from "./components/SearchActionButtons.vue";
import CalendarioComponent from "./components/CalendarioComponent.vue";
import ModuloBuilder from "./components/ModuloBuilder.vue";
import VerificaOrdine from "./components/VerificaOrdine.vue";
import CompilaOnoffboardingForm from "./components/CompilaOnoffboardingForm.vue";
import DatatableRating from "./components/DatatableRating.vue";
import TabsDettaglio from "./components/TabsDettaglio.vue";
import Chat from './components/Chat.vue';
import ThreadChat from './components/ThreadChat.vue';
import MessaggioChat from './components/MessaggioChat.vue';
import PriorityDot from './components/PriorityDot.vue';
import AssegnatariCircles from './components/AssegnatariCircles.vue';
import UtenteTicketDatatable from './components/UtenteTicketDatatable.vue';
import Thread from './components/Thread.vue';
import TicketingTipoForm from './components/TicketingTipoForm.vue';
import OrariForm from './components/OrariForm.vue';
import TreeTableAdvance from './components/TreeTableAdvance.vue';
import TimingComponent from "./components/TimingComponent.vue";
import AiAssistant from './components/AiAssistant.vue';
import ImpostazioniGeneraliTicketForm from './components/ImpostazioniGeneraliTicketForm.vue';
import { requestPermission } from "./firebase";
import { initDynamicHeights } from "./dynamicHeight";

if (document.querySelector("#informazioni") != null){
    const info = document.getElementById("informazioni");
    const altezza = info.offsetHeight;
    document.documentElement.style.setProperty('--altezza-informazioni', `${altezza}px`);

}



axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
window.translations = {};

// Funzione per caricare le traduzioni
async function loadTranslations() {
    try {
        const response = await axios.get('/translations');
        window.translations = response.data.messages;
    } catch (error) {
        console.error('Errore nel caricamento delle traduzioni:', error);
    }
}

// Helpers per accedere alle traduzioni
window.trans = function (key) {
    return key.split('.').reduce((t, i) => (t ? t[i] : key), window.translations);
};

async function initializeApp() {
    await loadTranslations();
    const saveNotificationToken = async () => {
        const token = await requestPermission();

        if (!token) {
            return null;
        }

        try {
            await axios.post('/notifiche/token', {token: token});
            console.log('Token salvato');
        } catch (err) {
            console.error(err);
        }

        return token;
    };
    if (document.querySelector("#app") != null) {
        const appElement = document.querySelector("#app");
        appElement.innerHTML += "<Toast\>"
        const app = createApp({
            data() {
                return {
                    trans: window.translations,
                    mostraInfo: true,
                    mostraDettaglio: false,
                    altezzaInfo: 0,
                    modale : false,
                    anteprima : false,
                    chartFormLicenzeVisible: false,
                    roleId: null,
                    actionUrl: null,
                }
            },
            methods: {
                aprichiudi_info() {
                    this.mostraInfo = !this.mostraInfo;
                    this.aggiornaMargin();
                },
                aprichiudi_dettagliotabs(){
                    this.mostraDettaglio = !this.mostraDettaglio;
                },
                aggiornaMargin() {
                    const infoElement = document.querySelector('.informazioni');
                    if (infoElement) {
                        const toolbar = document.getElementById("toolbar");
                        const info = document.getElementById("informazioni");
                        const tabpanels = document.querySelector('.p-tabpanels');
                        const infoBottom = info.getBoundingClientRect().bottom;
                        const toolbarHeight = toolbar ? toolbar.offsetHeight : 0;
                        const padding = `calc(1rem + 1.125rem)`;
                        if (tabpanels) {
                            const h_tab = `calc(100vh - ${infoBottom + 80}px - ${padding})`;
                            tabpanels.style.height = h_tab;
                        }
                    }
                },
                toggleChartFormLicenze(payload) {
                    this.roleId = payload.data.role_id;
                    this.actionUrl = route('impostazioni/licenze/aggiungi',this.roleId);
                    this.chartFormLicenzeVisible = !this.chartFormLicenzeVisible;
                    console.log(this.chartFormLicenzeVisible)
                }
            },
            mounted() {
                // Imposta il margin iniziale
                this.$nextTick(() => {
                    this.aggiornaMargin();

                    // Osserva cambiamenti nel contenuto
                    const observer = new ResizeObserver(() => {
                        this.aggiornaMargin();
                    });

                    const infoElement = document.querySelector('.informazioni');
                    if (infoElement) {
                        observer.observe(infoElement);
                    }
                });
            }
        });
        window.filtriDatatable = function(type) {
            switch(type){
                case 'ticket':
                    return [
                        (a)=> Array.isArray(a.assegnatari) ? a.assegnatari[0].props.assegnatari.map((x)=> x.avatar.nome_completo).join(', ') : '',
                        (p)=> p.priorita[0].props.priorita,
                        (s)=> s.stato[0].props.value
                    ]
                    break
                case 'assistenza':
                    return [
                        (s)=> s.stato[0].props.value
                    ]
                    break
                default:
                    return []
                    break
            }
        }
        // di prime vue
        app.component('DialogPrime', Dialog)
        app.component('Form', Form);
        app.component('Card', Card);
        app.component('Fieldset', Fieldset);
        app.component('Toast', Toast);
        app.component('Tree', Tree);
        app.component('TreeTableAdvance', TreeTableAdvance);
        app.component('Column',Column);
        app.component('TabsDettaglio', TabsDettaglio);
        app.component('Chart', Chart);
        app.component('ButtonPrime',Button);
        app.component('ToggleSwitch',ToggleSwitch);
        app.use(ToastService);
        app.use(ConfirmationService);
        app.use(PrimeVue, {
            theme: {
                preset: MyPreset,
                options: {
                    darkModeSelector: false
                }
            },
            locale: window.translations
        });
        app.component('DatePicker', DatePicker);
        app.component('Tag', Tag);
        // nostri
        app.component('Login', Login);
        app.component('Register', Register)
        app.component('DatatableForm', DatatableForm)
        app.component('DatatableAdvance', DatatableAdvance)
        app.component('DatatableTicketing', DatatableTicketing)
        app.component('DatatableCellEdit', DatatableCellEdit)
        app.component('DatatableAdvanceExpandable', DatatableAdvanceExpandable)
        app.component('Grafici', Grafici)
        app.component('CustomDrawer', CustomDrawer);
        app.component('SingleForm', SingleForm)
        app.component('UpdateInfoThreadForm', UpdateInfoThreadForm)
        app.component('InnerThreadForm', InnerThreadForm)
        app.component('InnerThreadFormWithTabs', InnerThreadFormWithTabs)
        app.component('ButtonModalForm', ButtonModalForm)
        app.component('SeparaTicketModal', SeparaTicketModal)
        app.component('DipendentiForm', DipendentiForm)
        app.component('VerifyTicketForm', VerifyTicketForm)
        app.component('ConfirmTicket', ConfirmTicket)
        app.component('DdtForm', DdtForm)
        app.component('DdtInviaForm', DdtInviaForm)
        app.component('DatatableRowEdit', DatatableRowEdit)
        app.component('FileMultiploUpload', FileMultiploUpload)
        app.component('FileUploadMapped', FileUploadMapped)
        app.component('GiroSettimanale',GiroSettimanale)
        app.component('SearchActionButtons', SearchActionButtons)
        app.component('Calendario', CalendarioComponent);
        app.component('ModuloBuilder', ModuloBuilder);
        app.component('VerificaOrdine', VerificaOrdine);
        app.component('CompilaOnoffboardingForm', CompilaOnoffboardingForm);
        app.component('DatatableRating', DatatableRating);
        app.component('Chat', Chat);
        app.component('ThreadChat', ThreadChat);
        app.component('MessaggioChat', MessaggioChat);
        app.component('PriorityDot', PriorityDot);
        app.component('AssegnatariCircles', AssegnatariCircles);
        app.component('UtenteTicketDatatable', UtenteTicketDatatable);
        app.component('Thread', Thread);
        app.component('TicketingTipoForm', TicketingTipoForm)
        app.component('OrariForm', OrariForm)
        app.component('MenuStrumenti', MenuStrumenti)
        app.component('Timing', TimingComponent)
        app.component('AiAssistant', AiAssistant)
        app.component('ImpostazioniGeneraliTicketForm', ImpostazioniGeneraliTicketForm)
        app.use(VueReCaptcha, {
            siteKey: '6LedhKQsAAAAANsZF2ea0pr8VRxF8APZZeGFExYs',
            loaderOptions: {
                useRecaptchaNet: true,
                autoHideBadge: true
            }
        })
        app.directive('tooltip', Tooltip);
        app.mount('#app');
    }
  if(window.location.href.indexOf('admin/impostazioni') > -1){
    const piano = window.__PLAN__?.codice;
    console.log(piano)
      if(piano && piano == 'professional'){
        document.addEventListener('selectChanged',function(e){
          const { info, key, struttura } = e.detail;
          const value = info[key];
          if(key == 'pick_one_sso'){
            const new_struttura = {...struttura};
            const campi_google = ['google_client_id','google_client_secret'];
            const campi_microsoft = ['microsoft_client_id','microsoft_client_secret','microsoft_tenant_id'];

            if(value == 'google'){
              campi_google.forEach((campo)=> new_struttura[campo][1] = 'text')
              campi_microsoft.forEach((campo)=> new_struttura[campo][1] = 'hidden')
            }else if(value == 'microsoft'){
              campi_google.forEach((campo)=> new_struttura[campo][1] = 'hidden')
              campi_microsoft.forEach((campo)=> new_struttura[campo][1] = 'text')
            }else{
              [...campi_microsoft, ...campi_google].forEach((campo)=> new_struttura[campo][1] = 'hidden')
            }
            document.dispatchEvent(new CustomEvent('formChanged', {detail: {
              newStruttura : new_struttura
            }}));
          }

        })
      }
  }

    if (window.location.href.indexOf('/dipendente') > -1 || window.location.href.indexOf('/admin') > -1){



        if ("serviceWorker" in navigator) {
            navigator.serviceWorker
                .register("/firebase-messaging-sw.js")
                .then((registration) => {
                    console.log("Service Worker registered with scope:", registration.scope);
                })
                .catch((error) => {
                    console.error("Service Worker registration failed:", error);
                });
        }

        if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'granted') {
            await saveNotificationToken();
        }

    }

    if (document.querySelector("#header-dx") != null) {
        const mountHeaderDx = document.querySelector("#header-dx");
        const headerDx = createApp({
            data() {
                return {
                    trans: window.translations,
                    searchPopupVisible: false,
                    overlayMenuUtenteVisible: false,
                    overlayNotificheVisible: false,
                    toggleThemeMenuVisible: false,
                    searchQuery: '',
                    username: '',
                    datatableKey: 0,
                    nome: '',
                    cognome: '',
                    email: '',
                    colore: '#CCCCCC',
                    iniziali: '',
                    foto: '',
                    notifiche: [],
                    noNotificationsMessage: 'Nessuna notifica al momento.',
                    countnotifiche: 0,
                    tabCounts: {
                        clienti: 0,
                        dipendenti: 0,
                        automezzi: 0,
                        ticket: 0
                    }
                };
            },
            watch: {
                searchQuery: {
                    handler(newValue, oldValue) {
                        clearTimeout(this.searchTimeout);
                        this.searchTimeout = setTimeout(() => {
                            this.datatableKey++;
                            this.loadSearchCounts();
                        }, 300);
                    },
                    immediate: false,
                }
            },
            methods: {
                toggleSearchPopup() {
                    this.searchPopupVisible = !this.searchPopupVisible;
                    if (this.searchPopupVisible) {
                        this.loadSearchCounts();
                        this.$nextTick(() => {
                            if (this.$refs.searchInput) {
                                this.$refs.searchInput.focus();
                            }
                        });
                    }
                },
                toggleNotificationsOverlay() {
                    this.overlayNotificheVisible = !this.overlayNotificheVisible;
                    if (this.overlayNotificheVisible && this.notifiche.length === 0) {
                        this.loadNotifications();
                    }
                },
                overlayMenuUtente() {
                    this.overlayMenuUtenteVisible = !this.overlayMenuUtenteVisible;
                },
                async overlayNotifiche() {
                    this.overlayNotificheVisible = !this.overlayNotificheVisible;

                    if (typeof window !== 'undefined'
                        && 'Notification' in window
                        && Notification.permission === 'default') {
                        await saveNotificationToken();
                    }
                },
                toggleThemeMenu() {
                    this.toggleThemeMenuVisible = !this.toggleThemeMenuVisible;
                },
                handleSearchChange(event) {
                    this.searchQuery = event.target.value;
                },
                clearSearch() {
                    this.searchQuery = '';
                    this.loadSearchCounts();
                },
                closeMenus(event) {
                    const isOutsideNotifiche = !event.target.closest('.notifiche-sx') && this.overlayNotificheVisible;
                    const isOutsideUserMenu = !event.target.closest('.logo-sx-user') && this.overlayMenuUtenteVisible;
                    const isOutsideThemeMenu = !event.target.closest('#theme-menu') &&
                        !event.target.closest('[data-theme-toggle]') &&
                        this.toggleThemeMenuVisible;
                    const isOutsideSearchPopup = !event.target.closest('.search-container') && this.searchPopupVisible;
                    if (isOutsideUserMenu) {
                        this.overlayMenuUtenteVisible = false;
                    }

                    if (isOutsideThemeMenu) {
                        this.toggleThemeMenuVisible = false;
                    }

                    if (isOutsideNotifiche) {
                        this.overlayNotificheVisible = false;
                    }
                    if (isOutsideSearchPopup) {

                        this.searchPopupVisible = false;

                    }
                },
                triggerFileInput() {
                    this.$refs.fileInput.click();
                },
                handleFileChange(event) {
                    const file = event.target.files[0];
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.foto = e.target.result;
                    };
                    reader.readAsDataURL(file);
                    this.uploadPhoto(file);
                },
                uploadPhoto(file) {
                    const formData = new FormData();
                    formData.append('foto', file);
                    axios.post('/upload_photo', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                        .then(response => {
                            this.foto = response.data.foto;
                        })
                },
                removePhoto() {
                    this.foto = null;
                    this.$refs.fileInput.value = null;
                    axios.post('/remove_photo')
                        .then(response => {
                            console.log('Foto rimossa');
                        })
                        .catch(error => {
                            console.error('Errore nella rimozione', error);
                        });
                },
                loadUserInfo() {
                    axios.get('/menu_utente')
                        .then(response => {
                            const data = response.data;
                            this.username = data.username;
                            this.nome = data.nome;
                            this.cognome = data.cognome;
                            this.email = data.email;
                            this.colore = data.colore;
                            this.iniziali = data.iniziali;
                            this.ruolo = data.ruolo
                            if (data.foto) {
                                this.foto = data.foto;
                            }
                        })
                        .catch(error => {
                            console.error('Errore nel caricamento dei dati utente:', error);
                        });
                },
                loadNotifications() {
                    axios.get('/get_notifiche')
                        .then(response => {
                            let loadedNotifiche = response.data;
                            loadedNotifiche.sort((a, b) => {
                                const aIsDismissed = a.dataora_dismiss !== null;
                                const bIsDismissed = b.dataora_dismiss !== null;
                                if (!aIsDismissed && bIsDismissed) {
                                    return -1;
                                }
                                if (aIsDismissed && !bIsDismissed) {
                                    return 1;
                                }
                                return b.creato.localeCompare(a.creato);
                            });
                            this.notifiche = loadedNotifiche;
                            this.countnotifiche = this.notifiche.filter(n => n.dataora_dismiss === null).length;
                            if (this.notifiche.length === 0) {
                                this.noNotificationsMessage = 'Nessuna notifica al momento.';
                            } else {
                                this.noNotificationsMessage = '';
                            }
                        })
                        .catch(error => {
                            console.error('Errore nel caricamento delle notifiche:', error);
                        });
                },
                deleteNotifica(notificaId) {
                    console.log("Tentativo di eliminare la notifica con ID:", notificaId);
                    axios.post(`/delete_notifica/${notificaId}`) // Useremo un metodo POST/DELETE e passeremo l'ID nell'URL
                        .then(response => {
                            if (response.data.success) {
                                console.log(`Notifica ${notificaId} eliminata con successo.`);
                                this.notifiche = this.notifiche.filter(
                                    notifica => notifica.id !== notificaId
                                );
                                if (this.notifiche.length === 0) {
                                    this.noNotificationsMessage = 'Nessuna notifica al momento.';
                                }
                            } else {
                                console.error(`Errore logico nell'eliminazione della notifica ${notificaId}:`, response.data.message);
                            }
                        })
                        .catch(error => {
                            console.error(`Errore durante la chiamata Axios per eliminare la notifica ${notificaId}:`, error);
                            alert('Si è verificato un errore durante l\'eliminazione della notifica.');
                        });
                },
                dismissNotifica(notificaId) {
                    axios.post(`/dismiss_notifica/${notificaId}`)
                        .then(response => {
                            if (response.data.success) {
                                const index = this.notifiche.findIndex(n => n.id === notificaId);
                                if (index !== -1) {
                                    const updatedNotifiche = [...this.notifiche];

                                    updatedNotifiche[index] = {
                                        ...updatedNotifiche[index],
                                        dataora_dismiss: response.data.notifica.dataora_dismiss || new Date().toISOString()
                                    };

                                    this.notifiche = updatedNotifiche;

                                    this.notifiche.sort((a, b) => {
                                        const aIsDismissed = a.dataora_dismiss !== null;
                                        const bIsDismissed = b.dataora_dismiss !== null;

                                        if (!aIsDismissed && bIsDismissed) {
                                            return -1;
                                        }
                                        if (aIsDismissed && !bIsDismissed) {
                                            return 1;
                                        }
                                        return b.creato.localeCompare(a.creato);
                                    });
                                    this.countnotifiche = this.notifiche.filter(n => n.dataora_dismiss === null).length;
                                }
                            } else {
                                console.error(`Errore logico nel dismiss della notifica ${notificaId}:`, response.data.message);
                            }
                        })
                        .catch(error => {
                            console.error(`Errore durante la chiamata Axios per dismissare la notifica ${notificaId}:`, error);
                            alert('Si è verificato un errore durante il dismiss della notifica.');
                        });
                },
                loadSearchCounts() {
                    const params = {
                        search: this.searchQuery || ''
                    };
                    axios.get('/countricerca', { params: params })
                        .then(response => {
                            if (response.data) {
                                this.tabCounts = {
                                    clienti: response.data.clienti || 0,
                                    dipendenti: response.data.dipendenti || 0,
                                    automezzi: response.data.automezzi || 0,
                                    ticket: response.data.ticket || 0
                                };
                            }
                        })
                        .catch(error => {
                            console.error('Errore nel caricamento dei count di ricerca:', error);
                            this.tabCounts = {
                                clienti: 0,
                                dipendenti: 0,
                                automezzi: 0,
                                ticket: 0
                            };
                        });
                },
            },
            computed: {
                computedParamsClienti() {
                    return {
                        search: this.searchQuery
                    };
                },
                computedParamsDipendenti() {
                    return {
                        search: this.searchQuery
                    };
                },
                computedParamsAutomezzi() {
                    return {
                        search: this.searchQuery
                    };
                },
                computedParamsTicket() {
                    return {
                        search: this.searchQuery
                    };
                }
            },
            mounted() {
                document.addEventListener('click', this.closeMenus);
                this.loadUserInfo();
                this.loadNotifications();
            },
            beforeUnmount() {
                document.removeEventListener('click', this.closeMenus);
                if (this.searchTimeout) {
                    clearTimeout(this.searchTimeout);
                }
            },
        });
        headerDx.component('Card', Card);
        headerDx.component('TabsDettaglio', TabsDettaglio);
        headerDx.component('DatatableAdvance', DatatableAdvance)
        headerDx.use(PrimeVue, {
            theme: {
                preset: MyPreset,
                options: {
                    darkModeSelector: false
                }
            },
            locale: window.translations
        });
        headerDx.mount('#header-dx');
    }

    if (document.querySelector("#menu-sx") != null) {
        const mountMenuSx = document.querySelector("#menu-sx");
        const menu = createApp({
            data() {
                return {
                    trans: window.translations,
                }
            },
        });

        menu.use(PrimeVue, {
            theme: {
                preset: MyPreset,
                options: {
                    darkModeSelector: false
                }
            },
            locale: window.translations
        });
        menu.component('MenuSx', MenuSx)
        menu.mount('#menu-sx');
        const spaceMenu = document.querySelector('.space-menu');
        const menuOpener = document.querySelector('#menu-opener');

        if (menuOpener.classList.contains('menu-chiuso-container') &&
            menuOpener.querySelector('.barra-menu-grande')) {
            spaceMenu.style.display = 'block';
        } else {
            if(spaceMenu)spaceMenu.style.display = 'none';
        }

    }
    if (document.querySelector("#impostazioni") != null) {
        console.log("Impostazioni");
        const mountImpostazioni = document.querySelector("#impostazioni");
        mountImpostazioni.innerHTML += "<Toast\>"

        const impostazioni = createApp({
            data() {
                const dati_grafico = window.dati_grafico || [];

                return {
                    trans: window.translations,
                    popupElimina: false,
                    chartItems: dati_grafico.map(item => {
                        const spazioInGb = item.spazio / 1024;
                        const liberoInGb = item.totale - spazioInGb;
                        return {
                            titolo: item.cartella,
                            data: {
                                labels: [window.translations.occupato, window.translations.libero],
                                datasets: [
                                    {
                                        data: [spazioInGb, liberoInGb],
                                        backgroundColor: ['#42A5F5', '#E0E0E0'],
                                        hoverBackgroundColor: ['#64B5F6', '#BDBDBD'],
                                    },
                                ],
                            },
                        };
                    }),
                    chartOptions: {
                        cutout: "70%", // Per creare un effetto "doughnut" più sottile
                        responsive: true, // Il grafico si adatta alle dimensioni del contenitore
                        plugins: {
                            legend: {
                                display: true, // Mostra la legenda
                                position: "bottom", // Posiziona la legenda in basso
                                labels: {
                                    color: "#495057", // Colore del testo della legenda
                                    font: {
                                        size: 12, // Dimensione del font
                                    },
                                },
                            },
                        },
                    },
                }
            },
        });
        impostazioni.use(ToastService);
        impostazioni.use(PrimeVue, {
            theme: {
                preset: MyPreset,
                options: {
                    darkModeSelector: false
                }
            },
            locale: window.translations
        });
        impostazioni.component('Card', Card);
        impostazioni.component('SingleForm', SingleForm);
        impostazioni.component('ToggleSwitch', ToggleSwitch);
        impostazioni.component('Toast', Toast);
        impostazioni.component('DatatableAdvance', DatatableAdvance);
        impostazioni.component('Chart', Chart)
        impostazioni.component('DialogPrime', Dialog)
        impostazioni.mount('#impostazioni');
    }

    if (document.querySelector("#tools") != null) {
        const mountTools = document.querySelector("#tools");
        const tools = createApp({
            data() {
                return {
                    trans: window.translations,
                }
            },
        });

        tools.use(PrimeVue, {
            theme: {
                preset: MyPreset,
                options: {
                    darkModeSelector: false
                }
            },
            locale: window.translations
        });
        tools.component('MenuStrumenti', MenuStrumenti)
        tools.mount('#tools');
    }

    if (document.querySelector("#ticketingcontratto") != null){
        const mountTicketingContratto = document.querySelector("#ticketingcontratto");
        mountTicketingContratto.innerHTML += "<Toast\>"
        const ticketingContratto = createApp({
            data() {
                return {
                    trans: window.translations,
                    active: 'contrattogenerale',
                    disabled: {'contrattogenerale': false, 'contrattosla': true, 'emailAggiuntive': true},
                    numero_form_sla: 4
                }
            },
            methods: {
                salvaAccordion(nameref, nameref_successivo) {
                    var root = this;
                    if (nameref_successivo !== "") {
                        var vm_contrattogenerale = this.$refs['contrattogenerale'];
                        var vm_contrattosla = [];
                        var vm_mailaggiuntive = this.$refs['emailAggiuntive'];
                        for (var i = 1; i <= root.numero_form_sla; i++) {
                            vm_contrattosla[i] = this.$refs['contrattosla_' + i];
                        }
                    }

                    var vm = this.$refs[nameref];


                    var b = false;

                    var info = vm.info;

                    for (const [key, value] of Object.entries(vm.label)) {
                        if (typeof value[2] != "undefined" && value[2] !== "") {
                            if (value[2] === "required" && (info[key] === '' || info[key] === null)) {
                                vm.errors[key] = value[0] + vm.$root.trans.valore_richiesto;
                                b = true;
                            }
                            if (value[2] === "required" && (info[key] === 0 || info[key] === undefined) && (value[1] === "number" || value[1] === "numeratore" || value[1] === "select")) {
                                vm.errors[key] = value[0] + vm.$root.trans.valore_richiesto;
                                b = true;
                            }
                        }
                    }

                    if (!b) {
                        vm.info['_token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        try {
                            axios.post(vm.action, vm.info, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })
                                .then(function (response) {
                                    if (response.data.success) {
                                        root.$toast.add({
                                            severity: 'success',
                                            summary: root.$root.trans.success_form,
                                            detail: root.$root.trans.salvataggio_success,
                                            life: 3000
                                        });

                                        console.log('SUCCESS');
                                        for (const [key, value] of Object.entries(response.data.value)) {
                                            vm_contrattogenerale.info[key] = value;
                                            vm_mailaggiuntive.info[key] = value;
                                            for (var i = 1; i <= root.numero_form_sla; i++) {
                                                vm_contrattosla[i].info[key] = value;
                                            }
                                        }

                                        root.disabled[nameref_successivo] = false;
                                        root.active = nameref_successivo;

                                    } else {
                                        root.$toast.add({
                                            severity: 'danger',
                                            summary: root.$root.trans.errors_form,
                                            detail: root.$root.trans.salvataggio_errato,
                                            life: 3000
                                        });

                                    }
                                });
                        } catch (error) {
                            if (error.response && error.response.status === 401) {
                                root.$toast.add({
                                    severity: 'danger',
                                    summary: root.$root.trans.errors_form,
                                    detail: root.$root.trans.salvataggio_errato,
                                    life: 3000
                                });
                            }
                        }
                    }
                },
                salvaAccordionSla() {
                    var root = this;
                    var b = false;
                    var returnaxios = true;
                    var valori = [];

                    for (var i = 1; i <= root.numero_form_sla; i++) {
                        var vm = this.$refs['contrattosla_' + i];
                        valori[i - 1] = vm.info;
                        for (const [key, value] of Object.entries(vm.label)) {
                            if (typeof value[2] != "undefined" && value[2] !== "") {
                                if (value[2] === "required" && (valori[i - 1][key] === '' || valori[i - 1][key] === null)) {
                                    vm.errors[key] = value[0] + vm.$root.trans.valore_richiesto;
                                    b = true;
                                }
                                if (value[2] === "required" && (valori[i - 1][key] === 0 || valori[i - 1][key] === undefined) && value[1] === "number") {
                                    vm.errors[key] = value[0] + vm.$root.trans.valore_richiesto;
                                    b = true;
                                }
                            }
                        }
                    }

                    if (!b) {
                        var tk = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        try {
                            axios.post(vm.action, {slas: valori, _token: tk}, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })
                                .then(function (response) {
                                    if (response.data.success) {
                                        window.location.href = route(response.data.redirect);
                                    } else {
                                        returnaxios = false;
                                        root.$toast.add({
                                            severity: 'danger',
                                            summary: root.$root.trans.errors_form,
                                            detail: root.$root.trans.salvataggio_errato,
                                            life: 3000
                                        });

                                    }
                                });

                        } catch (error) {
                            if (error.response && error.response.status === 401) {
                                root.$toast.add({
                                    severity: 'danger',
                                    summary: root.$root.trans.errors_form,
                                    detail: root.$root.trans.salvataggio_errato,
                                    life: 3000
                                });
                            }
                        }
                    }

                }
            }
        });
        // di prime vue
        ticketingContratto.component('Card', Card);
        ticketingContratto.component('Accordion', Accordion);
        ticketingContratto.component('AccordionPanel', AccordionPanel);
        ticketingContratto.component('AccordionHeader', AccordionHeader);
        ticketingContratto.component('AccordionContent', AccordionContent);
        ticketingContratto.component('Toast', Toast);
        ticketingContratto.use(ToastService);
        ticketingContratto.use(PrimeVue, {
            theme: {
                preset: MyPreset,
                options: {
                    darkModeSelector: false
                }
            },
            locale: window.translations
        });
        // nostri
        ticketingContratto.component('FormInput', FormInput)
        ticketingContratto.mount('#ticketingcontratto');
    }

    if (document.querySelector("#nuovo_esterno") != null){
        const mountEsterniCrea = document.querySelector("#nuovo_esterno");
        mountEsterniCrea.innerHTML += "<Toast\>"
        const nuovo_esterno = createApp({
            data() {
                return {
                    trans: window.translations,
                    active: 'esternianagrafica',
                    disabled: {'esternianagrafica': false, 'permessiesterno': true,'utenteesterno': true},
                    numero_form_sla: 4
                }
            },
            mounted(){
                document.addEventListener('formChanged', function(e){
                    this.form[1]['struttura'] = e.detail.newStruttura;
                });
            },
            methods: {
                salvaAccordion(nameref, nameref_successivo) {
                    var root = this;
                    if (nameref_successivo !== "") {
                        var vm_esternianagrafica = this.$refs['esternianagrafica'];

                        var vm_permessiesterno = this.$refs['permessiesterno'];
                        var vm_utenteesterno = this.$refs['utenteesterno'];

                    }

                    var vm = this.$refs[nameref];


                    var b = false;

                    var info = vm.info;

                    for (const [key, value] of Object.entries(vm.label)) {
                        if (typeof value[2] != "undefined" && value[2] !== "") {
                            if (value[2] === "required" && (info[key] === '' || info[key] === null)) {
                                vm.errors[key] = value[0] + vm.$root.trans.valore_richiesto;
                                b = true;
                            }
                            if (value[2] === "required" && (info[key] === 0 || info[key] === undefined) && (value[1] === "number" || value[1] === "numeratore" || value[1] === "select")) {
                                vm.errors[key] = value[0] + vm.$root.trans.valore_richiesto;
                                b = true;
                            }
                        }
                    }

                    if (!b) {
                        vm.info['_token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        try {
                            axios.post(vm.action, vm.info, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })
                                .then(function (response) {
                                    if (response.data.success) {
                                        root.$toast.add({
                                            severity: 'success',
                                            summary: root.$root.trans.success_form,
                                            detail: root.$root.trans.salvataggio_success,
                                            life: 3000
                                        });

                                        console.log('SUCCESS');
                                        if(response.data.redirect){
                                            window.location.href = route(response.data.redirect,response.data.params);
                                        }
                                        for (const [key, value] of Object.entries(response.data.value)) {
                                            vm_esternianagrafica.info[key] = value;
                                            if (vm_permessiesterno) vm_permessiesterno.info[key] = value;
                                            vm_utenteesterno.info[key] = value;
                                        }

                                        root.disabled[nameref_successivo] = false;
                                        root.active = nameref_successivo;

                                    } else {
                                        root.$toast.add({
                                            severity: 'danger',
                                            summary: root.$root.trans.errors_form,
                                            detail: root.$root.trans.salvataggio_errato,
                                            life: 3000
                                        });

                                    }
                                });
                        } catch (error) {
                            if (error.response && error.response.status === 401) {
                                root.$toast.add({
                                    severity: 'danger',
                                    summary: root.$root.trans.errors_form,
                                    detail: root.$root.trans.salvataggio_errato,
                                    life: 3000
                                });
                            }
                        }
                    }
                },
            }
        });
        // di prime vue
        nuovo_esterno.component('Card', Card);
        nuovo_esterno.component('Accordion', Accordion);
        nuovo_esterno.component('AccordionPanel', AccordionPanel);
        nuovo_esterno.component('AccordionHeader', AccordionHeader);
        nuovo_esterno.component('AccordionContent', AccordionContent);
        nuovo_esterno.component('Toast', Toast);
        nuovo_esterno.use(ToastService);
        nuovo_esterno.use(PrimeVue, {
            theme: {
                preset: MyPreset,
                options: {
                    darkModeSelector: false
                }
            },
            locale: window.translations
        });
        // nostri
        nuovo_esterno.component('FormInput', FormInput)
        nuovo_esterno.mount('#nuovo_esterno');




        document.addEventListener('checkboxChanged', function(e){
            const {key, info, struttura} = e.detail;
            if(key === 'onoffboarding'){
                if(Object.keys({...info.onoffboarding}).length > 0){
                    const new_struttura = {...struttura}
                    new_struttura['onoffboarding_ticketing_team_id'][1] = "select"
                }else{
                    const new_struttura = {...struttura}
                    new_struttura['onoffboarding_ticketing_team_id'][1] = "hidden"
                }
                document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                        newStruttura : new_struttura
                    }}));
            }
        })
    }

    if (document.querySelector("#dipendentianagrafica") != null) {
        const mountdipendentiAnagrafica = document.querySelector("#dipendentianagrafica");
        mountdipendentiAnagrafica.innerHTML += "<Toast\>"
        const dipendentiAnagrafica = createApp({
            data() {
                return {
                    trans: window.translations,
                    active: 'anagrafica',
                    disabled: {'anagrafica': false, 'contrattoore': true, 'documenti': true},
                    numero_form_documenti: 5
                }
            },
            methods: {
                salvaAccordion(nameref, nameref_successivo) {
                    var root = this;
                    if (nameref_successivo !== "") {
                        var vm_anagrafica = this.$refs['anagrafica'];
                        var vm_contratto = this.$refs['contrattoore'];
                        var vm_documenti = [];
                        for (var i = 1; i <= root.numero_form_documenti; i++) {
                            vm_documenti[i] = this.$refs['documenti_' + i];
                        }
                    }

                    var vm = this.$refs[nameref];


                    var b = false;

                    var info = vm.info;

                    for (const [key, value] of Object.entries(vm.label)) {
                        if (typeof value[2] != "undefined" && value[2] !== "") {
                            if (value[2] === "required" && (info[key] === '' || info[key] === null)) {
                                vm.errors[key] = value[0] + vm.$root.trans.valore_richiesto;
                                b = true;
                            }
                            if (value[2] === "required" && (info[key] === 0 || info[key] === undefined) && value[1] === "number") {
                                vm.errors[key] = value[0] + vm.$root.trans.valore_richiesto;
                                b = true;
                            }
                        }
                    }

                    if (nameref === 'contrattoore') {
                        //controllo somme ore settimana con ore inserite nei giorni
                        var totalegioni = vm.info['ore_lunedi'] + vm.info['ore_martedi'] + vm.info['ore_mercoledi'] + vm.info['ore_giovedi'] + vm.info['ore_venerdi'] + vm.info['ore_sabato'] + vm.info['ore_domenica'];
                        if (vm.info['ore_settimanali'] > 0 && totalegioni > 0) {
                            if (vm.info['ore_settimanali'] !== totalegioni) {
                                vm.errors['ore_lunedi'] = vm.$root.trans.controllo_ore_contratto;
                                vm.errors['ore_martedi'] = vm.$root.trans.controllo_ore_contratto;
                                vm.errors['ore_mercoledi'] = vm.$root.trans.controllo_ore_contratto;
                                vm.errors['ore_giovedi'] = vm.$root.trans.controllo_ore_contratto;
                                vm.errors['ore_venerdi'] = vm.$root.trans.controllo_ore_contratto;
                                vm.errors['ore_sabato'] = vm.$root.trans.controllo_ore_contratto;
                                vm.errors['ore_domenica'] = vm.$root.trans.controllo_ore_contratto;
                                vm.errors['ore_settimanali'] = vm.$root.trans.controllo_ore_contratto;
                                b = true;
                            }
                        }
                    }

                    if (!b) {
                        vm.info['_token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        try {
                            axios.post(vm.action, vm.info, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })
                                .then(function (response) {
                                    if (response.data.success) {
                                        root.$toast.add({
                                            severity: 'success',
                                            summary: root.$root.trans.success_form,
                                            detail: root.$root.trans.salvataggio_success,
                                            life: 3000
                                        });
                                        if(response.data.redirect){
                                            window.location.href = route(response.data.redirect);
                                        }

                                        console.log('SUCCESS');
                                        for (const [key, value] of Object.entries(response.data.value)) {
                                            vm_anagrafica.info[key] = value;
                                            vm_contratto.info[key] = value;
                                            for (var i = 1; i <= root.numero_form_documenti; i++) {
                                                //if aggiungo perché in caso non abbiamo il modul HR attivo allora la tab documenti non è attiva
                                                if(vm_documenti[i])vm_documenti[i].info[key] = value;
                                            }
                                        }

                                        root.disabled[nameref_successivo] = false;
                                        root.active = nameref_successivo;

                                    } else {
                                        root.$toast.add({
                                            severity: 'danger',
                                            summary: root.$root.trans.errors_form,
                                            detail: root.$root.trans.salvataggio_errato,
                                            life: 3000
                                        });

                                    }
                                });
                        } catch (error) {
                            if (error.response && error.response.status === 401) {
                                root.$toast.add({
                                    severity: 'danger',
                                    summary: root.$root.trans.errors_form,
                                    detail: root.$root.trans.salvataggio_errato,
                                    life: 3000
                                });
                            }
                        }
                    }
                },
                salvaAccordionDocumenti() {
                    var root = this;
                    var b = false;
                    var returnaxios = true;
                    var valori = [];

                    for (var i = 1; i <= root.numero_form_documenti; i++) {
                        var vm = this.$refs['documenti_' + i];
                        valori[i - 1] = vm.info;
                        for (const [key, value] of Object.entries(vm.label)) {
                            if (typeof value[2] != "undefined" && value[2] !== "") {
                                if (value[2] === "required" && (valori[i - 1][key] === '' || valori[i - 1][key] === null)) {
                                    vm.errors[key] = value[0] + vm.$root.trans.valore_richiesto;
                                    b = true;
                                }
                                if (value[2] === "required" && (valori[i - 1][key] === 0 || valori[i - 1][key] === undefined) && value[1] === "number") {
                                    vm.errors[key] = value[0] + vm.$root.trans.valore_richiesto;
                                    b = true;
                                }
                            }
                        }
                    }

                    if (!b) {
                        var tk = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        try {
                            axios.post(vm.action, {documenti: valori, _token: tk}, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })
                                .then(function (response) {
                                    if (response.data.success) {
                                        window.location.href = route(response.data.redirect);
                                    } else {
                                        returnaxios = false;
                                        root.$toast.add({
                                            severity: 'danger',
                                            summary: root.$root.trans.errors_form,
                                            detail: root.$root.trans.salvataggio_errato,
                                            life: 3000
                                        });

                                    }
                                });

                        } catch (error) {
                            if (error.response && error.response.status === 401) {
                                root.$toast.add({
                                    severity: 'danger',
                                    summary: root.$root.trans.errors_form,
                                    detail: root.$root.trans.salvataggio_errato,
                                    life: 3000
                                });
                            }
                        }
                    }
                },
                showTeam(){
                    console.log('showTeam');
                }
            }
        });
        // di prime vue
        dipendentiAnagrafica.component('Card', Card);
        dipendentiAnagrafica.component('Accordion', Accordion);
        dipendentiAnagrafica.component('AccordionPanel', AccordionPanel);
        dipendentiAnagrafica.component('AccordionHeader', AccordionHeader);
        dipendentiAnagrafica.component('AccordionContent', AccordionContent);
        dipendentiAnagrafica.component('Toast', Toast);
        dipendentiAnagrafica.use(ToastService);
        dipendentiAnagrafica.use(PrimeVue, {
            theme: {
                preset: MyPreset,
                options: {
                    darkModeSelector: false
                }
            },
            locale: window.translations
        });
        // nostri
        dipendentiAnagrafica.component('FormInput', FormInput)
        dipendentiAnagrafica.mount('#dipendentianagrafica');

        document.addEventListener('checkboxChanged', function(e){
            const key = e.detail.key;
            const value = e.detail.info[key];
            const struttura = e.detail.struttura;
            if(key === 'crea_utente_team'){
                if(value[0] == 1){
                    struttura.ticketingteam_id[1] = "select"
                }else{
                    struttura.ticketingteam_id[1] = "hidden"
                }
            }
        })

    }

    if (document.querySelector("#clientianagrafica") != null) {
        const mountClientiAnagrafica = document.querySelector("#clientianagrafica");
        mountClientiAnagrafica.innerHTML += "<Toast\>";
        const clienti_id = window.clienti_id || 0;
        console.log('clienti.id '+clienti_id);
        const clientiAnagrafica = createApp({
            data() {
                return {
                    trans: window.translations,
                    active: 'anagrafica',
                    disabled: {
                        'anagrafica': false,
                        'cantiere': true,
                        'contratto': true ,
                        'servizi' : true,
                        'documenti' : true ,
                        'economics' : true ,
                        'economics_servizi' : true
                    },
                }
            },
            mounted() {
                if(clienti_id > 0){
                    this.disabled['anagrafica'] = false;
                    this.disabled['cantiere'] = false;
                    this.active = 'cantiere';
                }
            },
            methods: {
                salvaAccordion(nameref, nameref_successivo , nameref_terzo, crea_contratto = false) {
                    var root = this;
                    if (nameref_successivo !== "") {
                        var vm_anagrafica = this.$refs['anagrafica'];
                        var vm_cantiere = this.$refs['cantiere'];
                        var vm_contratto = this.$refs['contratto'];
                    }

                    var vm = this.$refs[nameref];
                    var b = false;
                    var info = vm.info;

                    for (const [key, value] of Object.entries(vm.label)) {
                        if (typeof value[2] != "undefined" && value[2] !== "") {
                            if (value[2] === "required" && (info[key] === '' || info[key] === null)) {
                                vm.errors[key] = value[0] + vm.$root.trans.valore_richiesto;
                                b = true;
                            }
                            if (value[2] === "required" && (info[key] === 0 || info[key] === undefined) && value[1] === "number") {
                                vm.errors[key] = value[0] + vm.$root.trans.valore_richiesto;
                                b = true;
                            }
                        }
                    }

                    if (!b) {
                        vm.info['_token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        if(crea_contratto){
                            vm.info['crea_contratto_ticketing'] = 1;
                        }
                        axios
                            .post(vm.action, vm.info, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })
                            .then(function (response) {
                                if (response.data.success) {
                                    root.$toast.add({
                                        severity: 'success',
                                        summary: root.$root.trans.success_form,
                                        detail: root.$root.trans.salvataggio_success,
                                        life: 3000
                                    });

                                    console.log('SUCCESS');
                                    if(nameref_successivo == '' && response.data.redirect) {
                                        console.log(response.data.redirect);
                                        console.log(response.data.value.contratto_id);
                                        const id = response.data.value.contratto_id ?? response.data.value.id;
                                        window.location.href = route(response.data.redirect, { id: id });
                                    }else{

                                        for (const [key, value] of Object.entries(response.data.value)) {
                                            vm_anagrafica.info[key] = value;
                                            vm_cantiere.info[key] = value;
                                            vm_contratto.info[key] = value;
                                        }

                                        root.disabled[nameref_successivo] = false;
                                        root.active = nameref_successivo;

                                        if(typeof nameref_terzo != "undefined"){
                                            root.copiaIn(nameref, nameref_successivo , nameref_terzo)
                                        }
                                    }

                                } else {
                                    var mex =  root.$root.trans.salvataggio_errato
                                    if(response.data.messages){
                                        mex = response.data.messages;
                                    }
                                    if(response.data.mostra_errors){
                                        vm.errors = response.data.mostra_errors
                                    }
                                    root.$toast.add({
                                        severity: 'danger',
                                        summary: root.$root.trans.errors_form,
                                        detail: mex,
                                        life: 3000
                                    });

                                }
                            })
                            .catch(function (error) {
                                if (error.response) {
                                    root.$toast.add({
                                        severity: 'danger',
                                        summary: root.$root.trans.errors_form,
                                        detail: root.$root.trans.salvataggio_errato,
                                        life: 3000
                                    });
                                }
                            })
                    }
                },
                copiaIn(nome_pieno , nome_vuoto, nome_successivo){
                    var pieno = this.$refs[nome_pieno];
                    var vuoto = this.$refs[nome_vuoto];
                    for (const [key, value] of Object.entries(pieno.info)) {
                        if(key === "ragione_sociale" ){
                            vuoto.info['nome_cantiere'] = value;
                        }else if(key === 'nome'){
                            vuoto.info['referente'] = value;
                        }else if(key === 'cognome'){
                            vuoto.info['referente'] = vuoto.info['referente']+" "+value;
                        }else{
                            vuoto.info[key] = value;
                        }
                    }
                    this.salvaAccordion(nome_vuoto , nome_successivo)
                }
            }
        });
        // di prime vue
        clientiAnagrafica.component('Card', Card);
        clientiAnagrafica.component('Accordion', Accordion);
        clientiAnagrafica.component('AccordionPanel', AccordionPanel);
        clientiAnagrafica.component('AccordionHeader', AccordionHeader);
        clientiAnagrafica.component('AccordionContent', AccordionContent);
        clientiAnagrafica.component('Toast', Toast);
        clientiAnagrafica.use(ToastService);
        clientiAnagrafica.use(PrimeVue, {
            theme: {
                preset: MyPreset,
                options: {
                    darkModeSelector: false
                }
            },
            locale: window.translations
        });
        // nostri
        clientiAnagrafica.component('FormInput', FormInput)
        clientiAnagrafica.mount('#clientianagrafica');
    }

    if (document.querySelector("#cantiericontrattonuovo") != null) {
        const mountCantieriContrattoNuovo = document.querySelector("#cantiericontrattonuovo");
        mountCantieriContrattoNuovo.innerHTML += "<Toast\>"
        const select = window.select;
        const dati_preset = window.dati_preset;
        const cantieriContrattoNuovo = createApp({
            data() {
                return {
                    trans: window.translations,
                    active: 'contratto',
                    disabled: {
                        'contratto': false ,
                        'servizi' : true,
                        'timing' : true ,
                        'economics' : true ,
                        'economics_servizi' : true
                    },
                    select: select,
                    dati_preset: dati_preset
                }
            },
            /*beforeMount() {
              if(typeof this.$refs.contratto == "undefined"){
                  this.active = 'timing';
                  this.disabled.timing = false;
              }
            },*/
            watch: {
                'select.nome_preset' : function() {
                    var vm = this;
                    var scelta = this.select.nome_preset;
                    axios.get(route('clienti/cantieri/contratti/scelta_preset', {'id': scelta}))
                        .then(function (response) {
                            console.log(response.data);
                            console.log(vm.$refs.preset.info);
                            vm.$refs.preset.info = response.data
                        })
                        .catch(function (error) {
                            console.error('Errore nella richiesta:', error);
                        });
                },
                deep: true
            },
            methods: {
                salvaAccordion(nameref, nameref_successivo) {
                    var root = this;
                    console.log(nameref);
                    console.log(nameref_successivo);

                    if (nameref_successivo !== "") {
                        var vm_contratto = this.$refs['contratto'];
                        var vm_economics = this.$refs['economics'];
                        var vm_economics_servizi = this.$refs['economics_servizi'];
                        var vm_timing = this.$refs['timing'];
                    }

                    var vm = this.$refs[nameref];
                    var b = false;
                    var info = vm.info;

                    if(nameref != 'timing') {
                        for (const [key, value] of Object.entries(vm.label)) {
                            if (typeof value[2] != "undefined" && value[2] !== "") {
                                if (value[2] === "required" && (info[key] === '' || info[key] === null)) {
                                    vm.errors[key] = value[0] + vm.$root.trans.valore_richiesto;
                                    b = true;
                                }
                                if (value[2] === "required" && (info[key] === 0 || info[key] === undefined) && value[1] === "number") {
                                    vm.errors[key] = value[0] + vm.$root.trans.valore_richiesto;
                                    b = true;
                                }
                            }
                        }
                    } else {
                        var vm1 = this.$refs['preset'];
                        for (const [key, value] of Object.entries(vm1.label)) {
                            if (typeof value[2] != "undefined" && value[2] !== "") {
                                if (value[2] === "required" && (info[key] === '' || info[key] === null)) {
                                    vm1.errors[key] = value[0] + vm1.$root.trans.valore_richiesto;
                                    b = true;
                                }
                                if (value[2] === "required" && (info[key] === 0 || info[key] === undefined) && value[1] === "number") {
                                    vm1.errors[key] = value[0] + vm1.$root.trans.valore_richiesto;
                                    b = true;
                                }
                            }
                        }
                    }

                    if (!b) {
                        vm.info['_token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        console.log('invio info');
                        console.log(vm.info);
                        //console.log(vm1.info);
                        var parametri = vm.info;
                        if(nameref == 'timing') {
                            vm1.info['_token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                            vm1.info['contratto_id'] = vm.info['contratto_id'];
                            parametri = vm1.info;
                        }
                        axios
                            .post(vm.action, parametri, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })
                            .then(function (response) {
                                if (response.data.success) {
                                    root.$toast.add({
                                        severity: 'success',
                                        summary: root.$root.trans.success_form,
                                        detail: root.$root.trans.salvataggio_success,
                                        life: 3000
                                    });

                                    if(nameref_successivo == '') {
                                        console.log(response.data.redirect);
                                        console.log(response.data.value.contratto_id);
                                        // se è attivo il modulo clienti allora riceverà il parametro contratto id
                                        // in caso contrario riceve il parametro id ( corrispondente all'id del cliente )
                                        // prendo quindi l'id che ricevo a seconda del caso
                                        const id = response.data.value.contratto_id ?? response.data.value.id
                                        window.location.href = route(response.data.redirect, { id: id });
                                    } else {
                                        for (const [key, value] of Object.entries(response.data.value)) {
                                            vm_contratto.info[key] = value;
                                            if(typeof vm_economics != "undefined"){
                                                vm_economics.info[key] = value;
                                                vm_economics_servizi.info[key] = value;
                                            }

                                            vm_timing.info[key] = value;
                                        }

                                        root.disabled[nameref_successivo] = false;
                                        root.active = nameref_successivo;
                                    }

                                } else {
                                    var mex =  root.$root.trans.salvataggio_errato
                                    if(response.data.messages){
                                        mex = response.data.messages;
                                    }
                                    if(response.data.mostra_errors){
                                        vm.errors = response.data.mostra_errors
                                    }
                                    root.$toast.add({
                                        severity: 'danger',
                                        summary: root.$root.trans.errors_form,
                                        detail: mex,
                                        life: 3000
                                    });

                                }
                            })
                            .catch(function (error) {
                                if (error.response) {
                                    root.$toast.add({
                                        severity: 'danger',
                                        summary: root.$root.trans.errors_form,
                                        detail: root.$root.trans.salvataggio_errato,
                                        life: 3000
                                    });
                                }
                            })
                    }
                },
            }
        });
        // di prime vue
        cantieriContrattoNuovo.component('Card', Card);
        cantieriContrattoNuovo.component('Accordion', Accordion);
        cantieriContrattoNuovo.component('AccordionPanel', AccordionPanel);
        cantieriContrattoNuovo.component('AccordionHeader', AccordionHeader);
        cantieriContrattoNuovo.component('AccordionContent', AccordionContent);
        cantieriContrattoNuovo.component('Toast', Toast);
        cantieriContrattoNuovo.use(ToastService);
        cantieriContrattoNuovo.use(PrimeVue, {
            theme: {
                preset: MyPreset,
                options: {
                    darkModeSelector: false
                }
            },
            locale: window.translations
        });
        // nostri
        cantieriContrattoNuovo.component('FormInput', FormInput)
        cantieriContrattoNuovo.mount('#cantiericontrattonuovo');
    }

    if (document.querySelector("#credenzialiinvia") != null) {
        const mountCredenzialiInvia = document.querySelector("#credenzialiinvia");
        mountCredenzialiInvia.innerHTML += "<Toast\>"
        const lista = window.lista;
        const credenzialiInvia = createApp({
            data() {
                return {
                    trans: window.translations,
                    lista: lista,
                }
            },
            methods: {
                async copia_clipboard(mytext) {
                    var vm = this;
                    await navigator.clipboard.writeText(mytext);

                    vm.$toast.add({
                        severity: 'success',
                        summary: vm.$root.trans.success_copy,
                        detail: vm.$root.trans.dato_copiato,
                        life: 3000
                    });

                },
                invia_email() {
                    const vm = this;
                    try {
                        axios.post(route('dipendenti/credenziali/invia'), {'lista': vm.lista})
                            .then(function (response) {
                                console.log(response.data)
                                if (response.data.error.length > 0) {
                                    this.$toast.add({
                                        severity: 'warn',
                                        summary: 'Warning',
                                        detail: vm.$root.trans.error.join(', '),
                                        life: 3000
                                    });
                                } else {
                                    vm.$toast.add({
                                        severity: 'success',
                                        summary: 'Success',
                                        detail: vm.$root.trans.credenziali_inviate_correttamente,
                                        life: 3000
                                    });
                                }
                                window.location.href = route(response.data.redirect);

                            }.bind(this));
                    } catch (error) {
                        if (error.response && error.response.status === 401) {
                            vm.$toast.add({
                                severity: 'danger',
                                summary: vm.$root.trans.errors_form,
                                detail: vm.$root.trans.salvataggio_errato,
                                life: 3000
                            });
                        }
                    }
                },
                chiudi(){
                    try {
                        axios.post(route('dipendenti/credenziali/invia_chiudi'))
                            .then(function (response) {
                                window.location.href = route(response.data.redirect);
                            }.bind(this));
                    } catch (error) {
                        if (error.response && error.response.status === 401) {
                            vm.$toast.add({
                                severity: 'danger',
                                summary: vm.$root.trans.errors_form,
                                detail: vm.$root.trans.salvataggio_errato,
                                life: 3000
                            });
                        }
                    }
                }
            }
        });
        credenzialiInvia.use(ToastService);
        credenzialiInvia.component('Toast', Toast);
        credenzialiInvia.component('Card', Card);
        credenzialiInvia.component('ButtonPrime', Button);
        credenzialiInvia.component('Toast', Toast);
        credenzialiInvia.mount('#credenzialiinvia');
    }

    if (document.querySelector("#assenzemaschera") != null) {
        const mountAssenzeMaschera = document.querySelector("#assenzemaschera");
        mountAssenzeMaschera.innerHTML += "<Toast\>"
        const dati = window.dati;
        const struttura = window.struttura;
        const ore_giorno = window.ore_giorno;
        const struttura_giorno = window.struttura_giorno;
        const assenzeMaschera = createApp({
            data() {
                return {
                    trans: window.translations,
                    dati: dati,
                    struttura: struttura,
                    esiste_giorno: [],
                    giorni: [],
                    ore_giorno: ore_giorno,
                }
            },
            watch: {
                'dati.data_inizio': function () {
                    if(this.dati.data_fine !== "" && this.dati.data_inizio !== "" ){
                        this.contaGiorni( )
                    }
                },
                'dati.data_fine': function () {
                    if(this.dati.data_fine !== "" && this.dati.data_inizio !== "" ){
                        this.contaGiorni()
                    }
                },
                'giorni': {
                    handler(newVal, oldVal) {
                        // Questo watcher viene eseguito quando l'array giorni viene modificato
                        // Controlla se qualche elemento ha modificato la proprietà intera_giornata
                        if(typeof this.$refs.giorno != "undefined"){
                            for (let i = 0; i < newVal.length; i++) {
                                if(typeof newVal[i] != "undefined") {
                                    if (!newVal[i].intera_giornata) {
                                        if (typeof this.$refs.giorno[i] !== "undefined" && this.$refs.giorno[i].length !== 0) {
                                            this.$nextTick(() => {
                                                this.$refs.giorno[i]['label']['ora_inizio'][1] = 'time';
                                                this.$refs.giorno[i]['label']['ora_fine'][1] = 'time';
                                            });
                                        }
                                    } else {
                                        if (typeof this.$refs.giorno[i] !== "undefined" && this.$refs.giorno[i].length !== 0) {
                                            this.$nextTick(() => {
                                                this.$refs.giorno[i]['label']['ora_inizio'][1] = 'hidden';
                                                this.$refs.giorno[i]['label']['ora_fine'][1] = 'hidden';
                                            });
                                        }
                                    }
                                }
                            }
                        }else{
                        }
                    },
                    deep: true // Necessario per monitorare le modifiche profonde nell'array
                }
            },
            computed: {
                // Restituisce l'array `giorni` ordinato per data
                sortedGiorni() {
                    return [...this.giorni].sort((a, b) => {
                        if (!a.giorno) return 1; // Sposta l'oggetto senza "date" in fondo
                        if (!b.giorno) return -1; // Sposta l'oggetto senza "date" in fondo
                        return new Date(a.giorno) - new Date(b.giorno)
                    });
                }
            },
            methods: {
                contaGiorni: async function () {
                    console.log(new Date());
                    console.log(this.dati)
                    var start_date = new Date(this.createDateFromString(this.dati.data_inizio));
                    var end_date = new Date(this.createDateFromString(this.dati.data_fine));
                    var daysArray = [];
                    var removeArray = [];
                    while (start_date <= end_date) {
                        // Aggiungi la data corrente all'array (formattata o come oggetto Date).
                        var date = new Date(start_date)
                        var gg = this.formatDate(date)
                        var form_giorno = {
                            'giorno': date,
                            'gg': gg,
                            'ora_inizio': this.ore_giorno.inizio,
                            'ora_fine': this.ore_giorno.fine,
                            'totale_ore': this.ore_giorno[date.getDay()],
                            'intera_giornata': true
                        };

                        //controllo se esiste già il giorno non faccio nulla
                        if (this.giorni.length > 0) {
                            for (const key in this.giorni) {
                                var d1 = gg;
                                if (!this.esiste_giorno.includes(d1)) {
                                    console.log('insert ' + d1 + " " + gg);
                                    this.giorni.push(form_giorno);
                                    break;
                                }
                                break;
                            }
                        } else {
                            console.log('insert new ' + gg);
                            this.giorni.push(form_giorno);
                        }
                        daysArray.push(gg)
                        this.esiste_giorno.push(gg)
                        // Incrementa la data di 1 giorno
                        start_date.setDate(start_date.getDate() + 1);
                    }
                    for (const key in this.giorni) {
                        var d2 = this.giorni[key].gg;
                        if (!daysArray.includes(d2)) {
                            console.log('delete 1 ' + d2 + ' ' + key);
                            removeArray.push(d2) ;
                            this.giorni[key] = null;
                        }
                    }

                    for (const key in removeArray) {
                        for (const kgg in this.esiste_giorno) {
                            if (removeArray[key] == this.esiste_giorno[kgg]) {
                                console.log('delete 3 ' + this.esiste_giorno[kgg] + ' ' + key);
                                this.esiste_giorno.splice(kgg, 1)
                            }
                        }
                    }

                    console.log(this.giorni)
                    this.giorni = this.giorni.filter(item => item !== null );
                    console.log(this.giorni);
                    console.log(this.$refs.giorno);

                },
                formatDate(date) {
                    const d = new Date(date);
                    const day = String(d.getDate()).padStart(2, '0');
                    const month = String(d.getMonth() + 1).padStart(2, '0'); // I mesi sono indicizzati da 0
                    const year = d.getFullYear();
                    return `${day}-${month}-${year}`;
                },
                createDateFromString(dateString) {
                    // Dividi la stringa in giorno, mese e anno
                    if(typeof dateString === 'string') {
                        const [day, month, year] = dateString.split('-').map(Number);
                        // Crea un oggetto Date (il mese è 0-based, quindi sottrai 1)
                        return new Date(year, month - 1, day);

                    }else{
                        return dateString;
                    }
                },
                async controllaForm(){
                    var b = false;var vm = this;
                    b = await this.$refs['informazioni'].checkForm(3);
                    for(let i =  0; i < this.$refs['giorno'].length ; i++){
                        var r = await  this.$refs['giorno'][i].checkForm(3);
                        console.log(r);
                        if(r){
                            b = true;
                        }
                    }
                    if(!b){
                        try {
                            axios.post(route('dipendenti/assenze/salva'),
                                {
                                    'info' : vm.dati ,
                                    'giorni' : vm.giorni
                                },
                                {
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                    },
                                })
                                .then(function (response) {
                                    if (response.data.success) {
                                        this.$toast.add({
                                            severity: 'success',
                                            summary: this.$root.trans.success_form,
                                            detail: this.$root.trans.salvataggio_success,
                                            life: 3000
                                        });

                                        if(response.data.params){
                                            window.location.href = route(response.data.redirect , response.data.params);
                                        }else{
                                            window.location.href = route(response.data.redirect);
                                        }

                                    } else {
                                        if (response.data.message != null) {
                                            this.$toast.add({
                                                severity: 'errors',
                                                summary: this.$root.trans.errors_form,
                                                detail: this.$root.trans[response.data.message],
                                                life: 5000
                                            });
                                        } else {
                                            this.$toast.add({
                                                severity: 'errors',
                                                summary: this.$root.trans.errors_form,
                                                detail: this.$root.trans.salvataggio_errato,
                                                life: 3000
                                            });
                                        }
                                    }
                                }.bind(this));
                        } catch (error) {
                            if (error.response && error.response.status === 401) {
                                this.$toast.add({
                                    severity: 'errors',
                                    summary: this.$root.trans.errors_form,
                                    detail: this.$root.trans.salvataggio_errato,
                                    life: 3000
                                });
                            }
                        }
                    }

                }
            }
        });
        assenzeMaschera.use(ToastService);
        assenzeMaschera.component('Toast', Toast);
        assenzeMaschera.component('Card', Card);
        assenzeMaschera.component('ButtonPrime', Button);
        assenzeMaschera.component('Toast', Toast);
        assenzeMaschera.use(PrimeVue, {
            theme: {
                preset: MyPreset,
            },
            locale: window.translations
        });
        // nostri
        assenzeMaschera.component('FormInput', FormInput)
        assenzeMaschera.mount('#assenzemaschera');
    }

    if(window.location.href.indexOf("/support") > -1){
        document.addEventListener('textChanged', function(e){
            const key = e.detail.key;
            const value = e.detail.info[key];
            const struttura = e.detail.struttura;
            const form_data = e.detail.info



            axios.post(`/support/utente/tipologie-per-contratto-utente`,{
                email:value
            })
                .then(response => {
                    const data = response.data;
                    struttura.ticketingtipo_id[3] = [...data];
                    data.forEach((item)=>{
                        if(item.selected == true) form_data['ticketingtipo_id'] = item.id
                    })
                    document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                            newStruttura : struttura,
                            newData : form_data
                        }}));
                })
        })

        let sottotipologieTrovate = [];

        function updateSupportFormEditorSpan(dynamicFieldsCount) {
            requestAnimationFrame(() => {
                const form = document.querySelector('.support-form');
                if (!form) return;
                const editorDiv = form.querySelector(':scope > div[data-field="messaggio_originale"]');
                if (!editorDiv) return;
                if (dynamicFieldsCount >= 0) {
                    // span = sottotipologia(1) + campi extra(N) + allegati(1) = N + 2
                    editorDiv.style.gridRow = 'span ' + (dynamicFieldsCount + 2);
                } else {
                    editorDiv.style.gridRow = '';
                }
            });
        }

        document.addEventListener('selectChanged', function(e){
            const key = e.detail.key;
            const value = e.detail.info[key];

            if(key == 'ticketingtipo_id'){
                if(value == 0){
                    // pulisco i campi dinamici se l'utente torna al placeholder
                    let newStruttura = {...e.detail.struttura};
                    const form_data = e.detail.info;
                    const previousSottotipologie = Array.isArray(sottotipologieTrovate) ? sottotipologieTrovate : [];
                    previousSottotipologie.forEach((st)=>{
                        for (const nome_campo in st.campi) {
                            delete newStruttura[nome_campo];
                            delete form_data[nome_campo];
                        }
                    })
                    for(const k in newStruttura){
                        if(k.startsWith('extra_empty_')) delete newStruttura[k];
                    }
                    delete newStruttura.sottotipologia;
                    delete form_data.sottotipologia;
                    if(newStruttura.messaggio_originale){
                        newStruttura.messaggio_originale = [...newStruttura.messaggio_originale];
                        newStruttura.messaggio_originale[5] = '';
                    }
                    sottotipologieTrovate = [];
                    document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                        newStruttura : newStruttura,
                        newData: form_data
                    }}));
                    updateSupportFormEditorSpan(-1);
                    return;
                }
                axios.get(`/support/ticketing/informazioni-sottotipologie/${value}`).then((res)=>{
                    const data = Array.isArray(res.data) ? res.data : [];
                    if(data.length > 0){
                        // Pulisco i campi della selezione precedente prima di aggiungere i nuovi
                        let newStruttura = {...e.detail.struttura}
                        const form_data = e.detail.info

                        // rimuovo i campi extra della sottotipologia precedentemente selezionata
                        const previousSottotipologie = Array.isArray(sottotipologieTrovate) ? sottotipologieTrovate : [];
                        previousSottotipologie.forEach((st)=>{
                            for (const nome_campo in st.campi) {
                                delete newStruttura[nome_campo];
                                delete form_data[nome_campo];
                            }
                        })
                        // rimuovo i campi vuoti creati per il layout
                        for(const k in newStruttura){
                            if(k.startsWith('extra_empty_')) delete newStruttura[k];
                        }
                        // rimuovo la sottotipologia precedente (se presente) prima di inserire quella nuova
                        delete newStruttura.sottotipologia;
                        delete form_data.sottotipologia;
                        // rimuovo eventuale placeholder dal campo messaggio
                        if(newStruttura.messaggio_originale){
                            newStruttura.messaggio_originale = [...newStruttura.messaggio_originale];
                            newStruttura.messaggio_originale[5] = '';
                        }

                        sottotipologieTrovate = data;

                        const sottotipologiaField = [ "Sottotipologia", "select-on-change", "required", sottotipologieTrovate]
                        let keyValues = Object.entries(newStruttura);
                        const tipologiaIndex = keyValues.findIndex(([k]) => k === 'ticketingtipo_id');
                        keyValues.splice(tipologiaIndex + 1, 0, ['sottotipologia', sottotipologiaField]);
                        newStruttura = Object.fromEntries(keyValues);

                        form_data['sottotipologia'] = 0; // Imposta un valore predefinito

                        document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                                newStruttura : newStruttura,
                                newData: form_data
                            }}));
                        updateSupportFormEditorSpan(0);


                    }else{
                        // se non ritorna nessuna sottocategoria rimuovo la select sottocategoria
                        let newStruttura = {...e.detail.struttura};
                        delete newStruttura.sottotipologia;
                        const form_data = e.detail.info;
                        delete form_data.sottotipologia;
                        // rimuovo i campi extra aggiunti al form
                        const previousSottotipologie = Array.isArray(sottotipologieTrovate) ? sottotipologieTrovate : [];
                        previousSottotipologie.forEach((st)=>{
                            for (const nome_campo in st.campi) {
                                if(newStruttura[nome_campo]){
                                    delete newStruttura[nome_campo];
                                }
                                if(form_data[nome_campo]){
                                    delete form_data[nome_campo];
                                }
                            }
                        })
                        // rimuovo anche i campi vuoti creati per il latyout
                        for(const key in newStruttura){
                            if(key.startsWith('extra_empty_')){
                                delete newStruttura[key];
                            }
                        }
                        // rimuovo eventuale placeholder dal campo messaggio
                        if(newStruttura.messaggio_originale){
                            newStruttura.messaggio_originale = [...newStruttura.messaggio_originale];
                            newStruttura.messaggio_originale[5] = '';
                        }
                        //pulisco la viariabile sottotipologieTrovate
                        sottotipologieTrovate = [];
                        document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                                newStruttura : newStruttura,
                                newData: form_data
                            }}));
                        updateSupportFormEditorSpan(-1);
                    }


                })

            }else if(key == 'sottotipologia'){
                if(!Array.isArray(sottotipologieTrovate) || sottotipologieTrovate.length === 0){
                    return;
                }
                let newStruttura = {...e.detail.struttura}
                const form_data = e.detail.info

                // Rimuovi i campi precedentemente aggiunti dalla selezione della sottotipologia
                sottotipologieTrovate.forEach((st)=>{
                    for (const nome_campo in st.campi) {
                        if(newStruttura[nome_campo]){
                            delete newStruttura[nome_campo];
                        }
                        if(form_data[nome_campo]){
                            delete form_data[nome_campo];
                        }
                    }
                })
                // rimuovo anche i campi vuoti creati per il latyout
                for(const key in newStruttura){
                    if(key.startsWith('extra_empty_')){
                        delete newStruttura[key];
                    }
                }
                // rimuovo eventuale placeholder dal campo messaggio
                if(newStruttura.messaggio_originale){
                    newStruttura.messaggio_originale = [...newStruttura.messaggio_originale];
                    newStruttura.messaggio_originale[5] = '';
                }

                //identifico al sottotipologia scelta
                let counter = 0;
                const sottoTipologiaScelta = sottotipologieTrovate.find(item => item.id === value);
                if(sottoTipologiaScelta){
                    // creo i campi extra relativi alla sottotipologia scelta
                    // i campi avranno come name "extra_"+nome_scelto_in_impostazioni
                    const sottotipologiaIndex = Object.keys(newStruttura).indexOf('sottotipologia');
                    for (const nome_campo in sottoTipologiaScelta.campi) {
                        if (!Object.hasOwn(sottoTipologiaScelta.campi, nome_campo)) continue;
                        const descrizione_input = sottoTipologiaScelta.campi[nome_campo];

                        let keyValues = Object.entries(newStruttura);
                        keyValues.splice(sottotipologiaIndex + 1 + counter, 0, [nome_campo, descrizione_input]);
                        newStruttura = Object.fromEntries(keyValues);
                        form_data[nome_campo] = ''
                        counter++;
                    }
                }

                document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                        newStruttura : newStruttura,
                        newData: form_data
                    }}));
                updateSupportFormEditorSpan(counter);
            }



        })

    }

    if (window.location.href.indexOf("support/valuta") > -1) {

        document.addEventListener('ratingChanged', function(e){
            const { info, key, rating, struttura} = e.detail;
            let newOptions = [];
            let newField = null;
            let fieldLabel = null;
            const newStruttura = {...struttura}
            if( rating > 3 ){
                newField = "valutazione_opinione_positiva";
                fieldLabel = window.translations.ticketing_valutazione_opinione_positiva
                newOptions = [
                    {
                        id: "velocita",
                        nome: window.translations.ticketing_valutazione_opinione_positiva_velocita
                    },
                    {
                        id: "operatore",
                        nome: window.translations.ticketing_valutazione_opinione_positiva_operatore
                    },
                    {
                        id: "informazioni",
                        nome: window.translations.ticketing_valutazione_opinione_positiva_informazioni
                    }
                ];
            }else if( rating <= 2){
                newField = "valutazione_opinione_negativa";
                fieldLabel = window.translations.ticketing_valutazione_opinione_negativa
                newOptions = [
                    {
                        id: "velocita",
                        nome: window.translations.ticketing_valutazione_opinione_negativa_velocita
                    },
                    {
                        id: "operatore",
                        nome: window.translations.ticketing_valutazione_opinione_negativa_operatore
                    },
                    {
                        id: "informazioni",
                        nome: window.translations.ticketing_valutazione_opinione_negativa_informazioni
                    },
                ];
            }

            if( newField != null ){
                newStruttura.valutazione_opinione[0] = fieldLabel
                newStruttura.valutazione_opinione[1] = 'checkbox-multipla'
                newStruttura.valutazione_opinione[3] = newOptions
            }
            document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                    newStruttura : newStruttura
                }}));

        })
    }

    if (window.location.href.indexOf("ticketing/contratti/maschera") > -1) {
        document.addEventListener('selectChanged', function(e){
            const key = e.detail.key;
            const value = e.detail.info[key];

            if( key === 'pacchetto_ore'){
                const residuoLabel = document.querySelector('label[for="residuo"]');
                const riportoLabel = document.querySelector('label[for="riporto"]');
                if(value === 1){
                    residuoLabel.parentElement.parentElement.style.display = 'block';
                    riportoLabel.parentElement.parentElement.style.display = 'block';
                }else{
                    residuoLabel.parentElement.parentElement.style.display = 'none';
                    riportoLabel.parentElement.parentElement.style.display = 'none';

                }
            }
        })
        document.addEventListener('checkboxChanged', function(e){
            const key = e.detail.key;
            const value = e.detail.info[key];
            const struttura = e.detail.struttura;

            if(key ==="nuovo_ticket_da_risposta"){
                if(value[0] == 1){
                    struttura.soglia_giorni_nuovo_ticket[1] = 'hidden';
                }else{
                    struttura.soglia_giorni_nuovo_ticket[1] = 'numeratore';

                }
                document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                        newStruttura : struttura
                    }}));
            }
        })
    }

    if (window.location.href.indexOf("ticketing/maschera") > -1) {
        document.addEventListener('selectChanged', function(e){
            const key = e.detail.key;
            const value = e.detail.info[key];
            const struttura = e.detail.struttura;

            const role_base_route = window.location.href.indexOf("admin") > -1 ? 'admin' : 'dipendente';
            const form_data = e.detail.info
            if(key === 'ticketingtipo_id'){
                if(value != 0){

                    fetch(`/${role_base_route}/ticketing/team/utenti/per-tipo/${value}`)
                        .then(response => response.json())
                        .then(data => {
                            console.log(data,struttura);
                            if(struttura.ticketingutentiteam_id) {
                                struttura.ticketingutentiteam_id[3] = [...data];
                            }
                            document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                                    newStruttura : struttura
                                }}));
                        })
                }else{
                    if(struttura.ticketingutentiteam_id) {
                        struttura.ticketingutentiteam_id[3] = [];
                    }
                    document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                            newStruttura : struttura
                        }}));
                }
            }

            if(key === 'ticketingcontratti_id'){
                fetch(`/${role_base_route}/ticketing/contratti/priorita/select/${value}`)
                    .then(response => response.json())
                    .then(data => {
                        console.log(data)
                        struttura.ticketingpriorita_id[3] = [...data];


                        document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                                newStruttura : struttura
                            }}));


                        fetch(`/${role_base_route}/ticketing/contratti/tipologia/select/${value}`)
                            .then(response => response.json())
                            .then(data => {
                                console.log(data)
                                struttura.ticketingtipo_id[3] = [...data];

                                data.forEach((item)=>{
                                    if(item.selected == true) form_data['ticketingtipo_id'] = item.id
                                })


                                document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                                        newStruttura : struttura,
                                        newData : form_data
                                    }}));

                            })

                    })
            }

            if(key === 'email'){
                // per evitare chiamate al server inutili aspetto che venta selezionato un valore dall'elenco
                if(struttura.email[4].includes(value)){

                    axios.post(`/${role_base_route}/ticketing/contratti/utente/informazioni-da-mail`,{
                        mail:value
                    }).then((res)=>{
                        console.log(res)
                        const dati = e.detail.info
                        const { nome, cognome,contratto_id } = res.data.utente;
                        const input = document.querySelectorAll('input[type="text"]')
                        const data = e.detail.info
                        data['ticketingcontratti_id'] = contratto_id;

                        if(input){
                            input[1].value = nome
                            input[1].dispatchEvent(new Event('input'));
                            input[2].value = cognome
                            input[2].dispatchEvent(new Event('input'));
                        }

                        document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                                newStruttura : struttura,
                                newData : data
                            }}));


                        // sezione presa dalla modifica del contratto, esegue i medesimi step
                        // fare piccolo refactoring estrapolando in funzione
                        fetch(`/${role_base_route}/ticketing/contratti/priorita/select/${contratto_id}`)
                            .then(response => response.json())
                            .then(data => {
                                console.log(data)
                                struttura.ticketingpriorita_id[3] = [...data];


                                document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                                        newStruttura : struttura
                                    }}));


                                fetch(`/${role_base_route}/ticketing/contratti/tipologia/select/${contratto_id}`)
                                    .then(response => response.json())
                                    .then(data => {
                                        console.log(data)
                                        struttura.ticketingtipo_id[3] = [...data];

                                        data.forEach((item)=>{
                                            if(item.selected == true) form_data['ticketingtipo_id'] = item.id
                                        })


                                        document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                                                newStruttura : struttura,
                                                newData : form_data
                                            }}));

                                    })

                            })

                    }).catch((err)=>{
                        console.error(err)
                    })


                }
            }
        })
    }

    if (window.location.href.indexOf("ticketing/thread") > -1) {
        document.addEventListener('selectChanged', function(e){
            const key = e.detail.key;
            const value = e.detail.info[key];
            const struttura = e.detail.struttura;

            const role_base_route = window.location.href.indexOf("admin") > -1 ? 'admin' : 'dipendente';

            if(key === 'ticketingtipo_id'){
                fetch(`/${role_base_route}/ticketing/team/utenti/per-tipo/${value}`)
                    .then(response => response.json())
                    .then(data => {
                        struttura.ticketingutentiteam_id[3] = [...data];
                        const info = e.detail.info;
                        info.ticketingutentiteam_id = []
                        document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                                newStruttura : struttura,
                                newDati: info
                            }}));
                        const chips = document.querySelectorAll('.aggiornamento-informativa .p-multiselect-label-container .p-multiselect-chip-item');
                    })
            }
            // region modifica utente
            if(key === 'email'){
                // per evitare chiamate al server inutili aspetto che venta selezionato un valore dall'elenco
                if(struttura.email[4].includes(value)){

                    axios.post(`/${role_base_route}/ticketing/contratti/utente/informazioni-da-mail`,{
                        mail:value
                    }).then((res)=>{
                        console.log(res.data.utente)
                        const dati = e.detail.info
                        const { nome, cognome,id, email_aggiuntive, telefono, ruolo, note } = res.data.utente;
                        const input = document.querySelectorAll('.p-dialog-mask input[type="text"]')
                        const data = e.detail.info
                        data['nome'] = nome;
                        data['cognome'] = cognome;
                        data['id'] = id;
                        data['email_aggiuntive'] = email_aggiuntive;
                        data['telefono'] = telefono;
                        data['note'] = note;

                        document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                                newStruttura : struttura,
                                newData : data
                            }}));

                    }).catch((err)=>{
                        console.error(err)
                    })


                }
            }
            // endregion modifica utente


        })
    }

    if (window.location.href.indexOf("ddt/maschera") > -1) {
        document.addEventListener('selectChanged', function(e){
            const key = e.detail.key;
            const value = e.detail.info[key];
            const struttura = e.detail.struttura;

            if(key === 'cliente_id'){
                fetch(route("magazzino/ddt/cantieri", {cliente_id: value}))
                    .then(response => response.json())
                    .then(data => {
                        struttura.cantiere_id[3] = [...data];
                        document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                                newStruttura : struttura
                            }}));
                    })
            }

            console.log(key,value,struttura)
        })
    }

    if (window.location.href.indexOf("magazzino/prodotti/maschera") > -1 || window.location.href.indexOf("magazzino/dpi/maschera") > -1) {
        document.addEventListener('selectChanged', function(e){
            const key = e.detail.key;
            const value = e.detail.info[key];
            const struttura = e.detail.struttura;

            if(key === 'clienti_cantieri_id'){
                fetch(route("magazzino/scaffali/select", {sede_id: value}))
                    .then(response => response.json())
                    .then(data => {
                        struttura.scaffali_id[3] = [...data];
                        document.dispatchEvent(new CustomEvent('formChanged', {detail: {
                                newStruttura : struttura
                            }}));
                    })
            }

            console.log(key,value,struttura)
        })
    }

    if (document.querySelector("#clienti_home") != null) {
        const mountClientiHome = document.querySelector("#clienti_home");

        const clientiHome = createApp({
            data() {
                const dati_grafico = window.dati_grafico || [];
                return {
                    trans: window.translations,
                    popupElimina: false,
                    chartItems: dati_grafico.map(item => {
                        const spazioInGb = item.spazio / 1024;
                        const liberoInGb = item.totale - spazioInGb;
                        return {
                            titolo: item.cartella,
                            data: {
                                labels: [window.translations.occupato, window.translations.libero],
                                datasets: [
                                    {
                                        data: [spazioInGb, liberoInGb],
                                        backgroundColor: ['#42A5F5', '#E0E0E0'],
                                        hoverBackgroundColor: ['#64B5F6', '#BDBDBD'],
                                    },
                                ],
                            },
                        };
                    }),
                    chartOptions: {
                        cutout: "70%", // Per creare un effetto "doughnut" più sottile
                        responsive: true, // Il grafico si adatta alle dimensioni del contenitore
                        plugins: {
                            legend: {
                                display: true, // Mostra la legenda
                                position: "bottom", // Posiziona la legenda in basso
                                labels: {
                                    color: "#495057", // Colore del testo della legenda
                                    font: {
                                        size: 12, // Dimensione del font
                                    },
                                },
                            },
                        },
                    },
                }
            },
        });
        clientiHome.use(PrimeVue, {
            theme: {
                preset: MyPreset,
                options: {
                    darkModeSelector: false
                }
            },
            locale: window.translations
        });
        clientiHome.component('Card', Card);
        clientiHome.component('Chart', Chart)
        clientiHome.mount('#clienti_home');
    }

    /*if (document.querySelector("#adminprofilo") != null) {
      const mountAdminProfilo = document.querySelector("#adminprofilo");
      const adminProfilo = createApp({
        data() {
          return {
            trans: window.translations,
          }
        },
        methods: {
          cambia_password() {
            alert('POPUP CAMBIA PASSWORD');
          },
        }
      });

      adminProfilo.mount('#adminprofilo');
    }*/

    if (document.querySelector("#admin_dashboard") != null) {
        const mountAdminDashboard = document.querySelector("#admin_dashboard");

        const adminDashboard = createApp({
            data() {
                const dati_grafico_orizzontale = window.dati_grafico_orizzontale || [];
                const mesi = Object.values(window.translations.mesi).slice(0, 12);
                const numeri = Array.from({ length: 12 }, (_, i) => i * 12);

                return {
                    trans: window.translations,
                    popupElimina: false,
                    chartData: {
                        labels: numeri,
                        datasets: [
                            {
                                label: window.translations.ticket,
                                data: mesi.map((_, i) => dati_grafico_orizzontale[i]?.ticket || 0),
                                backgroundColor: '#C5E9C8',
                                hoverBackgroundColor: '#A3D9A5',
                                borderRadius: 10,
                            },
                            {
                                label: window.translations.ticket_ore_lavorate,
                                data: mesi.map((_, i) => dati_grafico_orizzontale[i]?.ore_lavorate || 0),
                                backgroundColor: '#4AA8A6',
                                hoverBackgroundColor: '#3C8F8D',
                                borderRadius: 10,
                            }
                        ]
                    },
                    chartOptions: {
                        responsive: true,
                        indexAxis: 'y',
                        layout: {
                            padding: {
                                bottom: 30
                            }
                        },
                        scales: {
                            x: {
                                min: 0,
                                max: 90,
                                ticks: {
                                    stepSize: 10
                                },
                                grid: {
                                    display: false
                                }
                            },
                            y: {
                                ticks: {
                                    callback: function(value, index) {
                                        return mesi[index] || "";
                                    }
                                },
                                grid: {
                                    display: true,
                                    color: "#ddd"
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                display: true,
                                position: 'top',
                                labels: {
                                    color: "#02324c",
                                    font: {
                                        size: 20,
                                        weight: '700',
                                    },
                                },
                            },
                        },
                        elements: {
                            bar: {
                                borderRadius: 10,
                            }
                        }
                    },
                };
            },
            mounted() {
                this.chartData = this.chartData;
                this.chartOptions = this.chartOptions;
            },
        });

        adminDashboard.use(PrimeVue, {
            theme: { preset: MyPreset, options: { darkModeSelector: false } },
            locale: window.translations,
        });

        adminDashboard.component('Card', Card);
        adminDashboard.component('Chart', Chart);
        adminDashboard.mount('#admin_dashboard');
    }

    if (document.querySelector("#admin_dashboard_ore_lavorate") != null) {
        const mountAdminDashboardOreLavorate = document.querySelector("#admin_dashboard_ore_lavorate");

        const adminDashboardOreLavorate = createApp({
            data() {
                const dati_grafico_ore_lavorate = window.dati_grafico_ore_lavorate || [];
                const mesi = Object.values(window.translations.mesi).slice(0, 12);

                return {
                    chartData: {
                        labels: mesi,
                        datasets: [
                            {
                                label: window.translations.ticket_ore_lavorate,
                                data: dati_grafico_ore_lavorate.map(item => item.ore_lavorate),
                                backgroundColor: '#FF6384',
                                borderRadius: 10,
                            }
                        ]
                    },
                    chartOptions: {
                        responsive: true,
                        scales: {
                            x: {
                                ticks: {
                                    stepSize: 1
                                },
                                grid: {
                                    display: true
                                }
                            },
                            y: {
                                grid: {
                                    display: true
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'top',
                            },
                        },
                    }
                };
            },
            mounted() {
                this.chartData = this.chartData;
                this.chartOptions = this.chartOptions;
            },
        });

        adminDashboardOreLavorate.use(PrimeVue, {
            theme: { preset: MyPreset, options: { darkModeSelector: false } },
            locale: window.translations,
        });

        adminDashboardOreLavorate.component('Card', Card);
        adminDashboardOreLavorate.component('Chart', Chart);
        adminDashboardOreLavorate.mount('#admin_dashboard_ore_lavorate');
    }

    if (document.querySelector("#grafico_verticale") != null) {
        const mountGraficoVerticale = document.querySelector("#grafico_verticale");

        const graficoVerticale = createApp({
            data() {
                const dati_grafico_verticale = window.dati_grafico_verticale || [];
                const mesi = Object.values(window.translations.mesi).slice(0, 12);

                return {
                    chartData: {
                        labels: mesi,
                        datasets: [
                            {
                                label: 'Ore Lavorate',
                                data: dati_grafico_verticale.map(item => item.ore_lavorate),
                                backgroundColor: '#4CAF50',
                            }
                        ]
                    },
                    chartOptions: {
                        responsive: true,
                        scales: {
                            x: {
                                grid: {
                                    display: true
                                }
                            },
                            y: {
                                grid: {
                                    display: true
                                }
                            }
                        }
                    }
                };
            },
            mounted() {
                this.chartData = this.chartData;
                this.chartOptions = this.chartOptions;
            },
        });

        graficoVerticale.use(PrimeVue, {
            theme: { preset: MyPreset, options: { darkModeSelector: false } },
            locale: window.translations,
        });

        graficoVerticale.component('Card', Card);
        graficoVerticale.component('Chart', Chart);
        graficoVerticale.mount('#grafico_verticale');
    }

    if (document.querySelector("#grafico_multi_axis") != null) {
        const mountGraficoMultiAxis = document.querySelector("#grafico_multi_axis");

        const graficoMultiAxis = createApp({
            data() {
                const dati_grafico_multi_axis = window.dati_grafico_multi_axis || [];
                const mesi = Object.values(window.translations.mesi).slice(0, 12);

                return {
                    chartData: {
                        labels: mesi,
                        datasets: [
                            {
                                label: 'Ore Lavorate',
                                data: dati_grafico_multi_axis.map(item => item.ore_lavorate),
                                yAxisID: 'y',
                                borderColor: '#FF5733',
                                fill: false,
                            },
                            {
                                label: 'Ticket',
                                data: dati_grafico_multi_axis.map(item => item.ticket),
                                yAxisID: 'y2',
                                borderColor: '#33FF57',
                                fill: false,
                            }
                        ]
                    },
                    chartOptions: {
                        responsive: true,
                        scales: {
                            y: {
                                position: 'left',
                            },
                            y2: {
                                position: 'right',
                                grid: {
                                    display: false
                                }
                            }
                        }
                    }
                };
            },
            mounted() {
                this.chartData = this.chartData;
                this.chartOptions = this.chartOptions;
            },
        });

        graficoMultiAxis.use(PrimeVue, {
            theme: { preset: MyPreset, options: { darkModeSelector: false } },
            locale: window.translations,
        });

        graficoMultiAxis.component('Card', Card);
        graficoMultiAxis.component('Chart', Chart);
        graficoMultiAxis.mount('#grafico_multi_axis');
    }
    // Inizializza le altezze dinamiche per tutti gli elementi .card-h-full
    initDynamicHeights();
}

initializeApp();
